import { useContext, useEffect, useRef } from 'react';
import { RealtimeContext, type RealtimeEvento } from './realtimeContext';

export function useRealtime() {
  return useContext(RealtimeContext);
}

/**
 * Escuta um tipo de evento da fila do usuario. O handler pode mudar a cada
 * render sem reabrir a assinatura.
 */
export function useRealtimeEvento(
  tipo: string,
  handler: (evento: RealtimeEvento) => void,
  enabled = true,
) {
  const { subscribe } = useRealtime();
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!enabled) return;
    return subscribe((evento) => {
      if (evento.tipo === tipo) handlerRef.current(evento);
    });
  }, [subscribe, tipo, enabled]);
}
